import { PriceSegmentType } from '@snap-types/models/price-segment';

export const priceSegmentNames: Record<PriceSegmentType, string> = {
  [PriceSegmentType.CustomerPotential]: 'Customer Potential',
  [PriceSegmentType.CustomerPortals]: 'Customer Portals',
  [PriceSegmentType.ProductOperationsCount]: 'Product Operations Count',
  [PriceSegmentType.ProductComplexity]: 'Product Complexity',
  [PriceSegmentType.MarketIndustry]: 'Market Industry',
  [PriceSegmentType.LastTransactionAge]: 'Last Transaction Age',
  [PriceSegmentType.LastGrossMargin]: 'Last Gross Margin',
};
